import { render } from "./HostsView.vue?vue&type=template&id=8844dcbc"
import script from "./HostsView.vue?vue&type=script&lang=js"
export * from "./HostsView.vue?vue&type=script&lang=js"

import "./HostsView.vue?vue&type=style&index=0&id=8844dcbc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__